import { motion } from "framer-motion";

// Interior page hero — light editorial.
export default function PageHero({ eyebrow, title, sub, children, kicker }) {
  return (
    <section className="relative overflow-hidden bg-[#F7F8FA] pt-32 pb-16 lg:pt-40 lg:pb-24" data-testid="page-hero">
      <div className="absolute inset-0 grid-pattern-light opacity-60" aria-hidden="true" />
      <div
        className="absolute -right-40 -top-40 h-96 w-96 rounded-full opacity-40 blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(22,119,255,0.25), transparent 70%)" }}
        aria-hidden="true"
      />
      <div className="ad-container relative">
        <div className="max-w-4xl">
          {eyebrow && (
            <motion.span initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="ad-eyebrow">
              {eyebrow}
            </motion.span>
          )}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 }}
            className="mt-5 display-lg text-[#111827]"
          >
            {title}
          </motion.h1>
          {sub && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.16 }}
              className="mt-6 max-w-2xl text-base leading-relaxed text-[#4B5563] sm:text-lg"
            >
              {sub}
            </motion.p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}
